import { NavigationSubItem } from "../navigation-item"

export class LockSubItem extends NavigationSubItem {
  readonly id = "lock"
  readonly label = "veSCALE"
  readonly href = "/lock"
  readonly iconName = "overview-icon"
  readonly isExternal = false
  readonly tabs = []
}
